module.exports = function() {
  return new Worker(__webpack_public_path__ + "1fcd00d0532953300dbe.worker.js");
};